import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<BeachClubPage data-id="element-4" />} data-id="element-3" />
        <Route path="/sup" element={<SUPPage data-id="element-6" />} data-id="element-5" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" />} data-id="element-7" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" />} data-id="element-9" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" />} data-id="element-11" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" />} data-id="element-13" />
        <Route path="/events" element={<EventsPage data-id="element-16" />} data-id="element-15" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-18" />} data-id="element-17" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-20" />} data-id="element-19" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-22" />} data-id="element-21" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-24" />} data-id="element-23" />
        <Route path="/admin" element={<AdminDashboard data-id="element-26" />} data-id="element-25" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-28" />} data-id="element-27" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-30" />} data-id="element-29" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-32" />} data-id="element-31" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-34" />} data-id="element-33" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-36" />} data-id="element-35" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-38" />} data-id="element-37" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-40" />} data-id="element-39" />
      </Routes>
      <ConditionalFloatingButton data-id="element-41" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on Water Tribe Fest page, Thank You page, or Tranzila Success page
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water') {
    return null;
  }
  return <FloatingJoinButton data-id="element-42" />;
}